// Genera 3 sonidos cortos vía Web Audio API (sin necesidad de archivos mp3).
// Reproduce localmente cuando el usuario tiene la app abierta y llega un push.

const SOUNDS = {
    default: { freqs: [880, 1100, 880], durations: [0.12, 0.12, 0.12] },
    bell:    { freqs: [1568, 1175, 1568, 1976], durations: [0.18, 0.18, 0.18, 0.25] },
    soft:    { freqs: [523, 659, 783], durations: [0.16, 0.16, 0.16] },
    alert:   { freqs: [1200, 800, 1200, 800], durations: [0.10, 0.10, 0.10, 0.10] },
};

export const SOUND_OPTIONS = [
    { key: 'default', label: 'Default (3 tonos altos)' },
    { key: 'bell',    label: 'Campana (4 tonos)' },
    { key: 'soft',    label: 'Suave (acorde mayor)' },
    { key: 'alert',   label: 'Alerta (alternado)' },
    { key: 'silent',  label: 'Silencio (solo notif del SO)' },
];

let audioCtx = null;
const getCtx = () => {
    if (typeof window === 'undefined') return null;
    if (!audioCtx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        audioCtx = new AC();
    }
    return audioCtx;
};

export function playNotificationSound(soundKey = 'default') {
    if (!soundKey || soundKey === 'silent') return;
    const cfg = SOUNDS[soundKey] || SOUNDS.default;
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === 'suspended') {
        ctx.resume().catch(() => {});
    }
    let t = ctx.currentTime;
    cfg.freqs.forEach((freq, i) => {
        const dur = cfg.durations[i] || 0.15;
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.25, t + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.001, t + dur);
        osc.connect(gain).connect(ctx.destination);
        osc.start(t);
        osc.stop(t + dur + 0.01);
        t += dur + 0.05;
    });
}
